var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightClickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16666"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 41",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#21C179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 33.415L28.415 40.83L43.245 26",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightClickIcon);
export default __webpack_public_path__ + "static/media/RightClickIcon.6e94559673dc7db0adc8c942a3d582bd.svg";
export { ForwardRef as ReactComponent };